export const DISABLED_CAPTCHA_COMPANY_UUIDS = ['5992dc38-b000-483a-a625-bf5f0337ffa8'];
